import { createSelector } from '@ngrx/store';
import * as fromLocalAuthorities from '../reducers/local-authorities.reducer';
import { AppState } from '@app/store/state';

export const selectLocalAuthoritiesState = (state: AppState) => state.localAuthorities;

export const selectLocalAuthorityEntities = createSelector(
    selectLocalAuthoritiesState,
    fromLocalAuthorities.getLocalAuthoritiesEntities
);

export const selectLocalAuthorities = createSelector(selectLocalAuthorityEntities, (entities) => {
    return Object.values(entities);
});

export const selectLocalAuthoritiesLoading = createSelector(
    selectLocalAuthoritiesState,
    fromLocalAuthorities.getLocalAuthoritiesLoading
);

export const selectLocalAuthoritiesLoaded = createSelector(
    selectLocalAuthoritiesState,
    fromLocalAuthorities.getLocalAuthoritiesLoaded
);

export const selectListOfSelectedLocalAuthorities = createSelector(
    selectLocalAuthoritiesState,
    fromLocalAuthorities.getSelectedLocalAuthorities
);
